import { Component, CustomElement } from "../../core/CustomElement";

export interface ICCCTwitterFeedState {
  account: string;
}

@Component("ccc-twitter-timeline", {
  template: require("./template.html").default,
  style: require("./style.scss").default,
  observedAttributes: ["account"],
})
export default class CCCTwitterTimeline extends CustomElement {
  state: ICCCTwitterFeedState = {
    account: "",
  };

  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    if (Object.hasOwnProperty.call(this.state, attr)) {
      if (_oldValue === null) {
        this.setKeyState(attr, newValue);
      } else {
        console.error("No account reloading");
      }
    }
  }

  watchAccount(): void {
    console.log("new account", this.state.account);

    // @ts-ignore
    twttr.widgets.createTimeline(
      {
        sourceType: "profile",
        screenName: this.state.account,
      },
      this.shadowDom.querySelector(".timeline"),
      {
        height: 300,
      }
    );
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  }
}
